import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { CuaHangBillFormat } from '../models/store_stalls.model';
import { ServerResponse } from '../models/types';

@Injectable()
export class CuaHangbillFormatService {
  url = '';

  constructor(
    private http: HttpClient,
    private storeBill: Store<CuaHangBillFormat>,
    @Inject('BASE_URL') baseUrl: string
  ) {
    this.url = baseUrl;
  }

  async GetBill(value: string) {
    return this.http.post(this.url + 'api/BillFormat/getdata_bill', { MaCH: value })
      .toPromise()
      .then((result: ServerResponse) => {
        if (result[0].code === 1) {
          this.storeBill.dispatch({ type: 'INIT_CuaHang', ch: result[0].data });
          return result[0].data;
        } else {
          throw new Error(result[0].message);
        }
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/CuaHangbillFormat.service.ts